import { Component, ReactNode, ErrorInfo } from 'react';
import { captureSentryException, setSentryErrorInfo } from '@utils';
import { ErrorPage, ErrorPageTypes } from '../ErrorPage';

interface IErrorBoundaryState {
    error: Error | null;
    errorInfo: ErrorInfo | null;
}

interface IErrorBoundaryProps {
    children: ReactNode;
}

export class ErrorBoundary extends Component<IErrorBoundaryProps, IErrorBoundaryState> {
    constructor(props: IErrorBoundaryProps) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        this.setState({ error, errorInfo });

        setSentryErrorInfo(errorInfo);
        captureSentryException(error);
    }

    render(): ReactNode {
        if (this.state.errorInfo) {
            return <ErrorPage type={ErrorPageTypes.INTERNAL_SERVER_ERROR} />;
        }

        // Normally, just render children
        return this.props.children;
    }
}
